<template>
    <div class="app-container">
      <ViewForm v-if="!$store.getters.cusId" />
      <ViewFormUser v-else />
    </div>
  </template>
  <script>
  import ViewForm from '@/views/center-business/csgOrder/internal/components/ViewForm.vue';
  import ViewFormUser from '@/views/center-business/csgOrder/internal/components/ViewFormUser.vue';
  export default {
    name: 'BusinessOrderInternalViewCSG',
    components: {
      ViewForm,
      ViewFormUser
    },
  };
  </script>
